import { Injectable } from "@angular/core";
import { ValorizationEdit } from "src/app/model/valorization-edit";
import { DataService } from "../data.service";
import { MedicalOrderScann } from "src/app/model/medical-order-scann";
import { Budget } from "src/app/model/budget/budget";
import { BudgetFilter } from "src/app/model/budget/budget-filter";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { ReportViewer } from "src/app/model/report-viewer";
import { BudgetSearchItem } from "src/app/model/budget/budget-search-item";
import { AuthService } from "../auth.service";

@Injectable({
  providedIn: "root",
})
export class BudgetService {
  constructor(public dataService: DataService, private authService: AuthService) {}

  private readonly createEndPoint: string = "/budget/create/";
  private readonly getNewEndPoint: string = "/budget/getNew/";
  private readonly getByPatientIdEndPoint: string = "/budget/getByPatientId/";
  private readonly getScannsEndPoint: string = "/budget/getScanns/";
  private readonly getReportEndPoint: string = "/budget/getReport/";
  private readonly enabledEndPoint: string = "/budget/enabled/";
  private readonly disabledEndPoint: string = "/budget/disabled/";
  private readonly sendMailEndPoint: string = "/budget/sendMail/";
  private readonly getByParametersEndPoint: string = "/budget/getByParameters/";
  private readonly budgetingIntegratedAdmisionEndPoint: string =
    "/budget/budgetingIntegratedAdmision/";


  async sendMail(group: string): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.sendMailEndPoint, { Group: group })
      .toPromise();
  }


  async enabled(budget: BudgetSearchItem): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.enabledEndPoint, budget)
      .toPromise();
  }

  async disabled(budget: BudgetSearchItem): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.disabledEndPoint, budget)
      .toPromise();
  }

  async getByParameters(
    from: Date,
    to: Date,
    viewExpired: boolean,
    viewDisabled: boolean,
    patientId?: number
  ): Promise<BudgetSearchItem[]> {
    const filter = {
      from: new Date(
        from.getFullYear(),
        from.getMonth(),
        from.getDate()
      ).toDateString(),
      to: new Date(
        to.getFullYear(),
        to.getMonth(),
        to.getDate()
      ).toDateString(),
      viewExpired,
      viewDisabled,
      patientId,
    };

    return await this.dataService
      .get<BudgetSearchItem[]>(this.getByParametersEndPoint, filter)
      .toPromise();
  }

  async getScanns(budgetId: number): Promise<MedicalOrderScann[]> {
    return await this.dataService
      .get<MedicalOrderScann[]>(this.getScannsEndPoint, { budgetId })
      .toPromise();
  }

  async budgetingIntegratedAdmision(
    appointment: IntegratedAdmissionAppointment,
    budgetId: number
  ): Promise<IntegratedAdmissionAppointment> {
    return await this.dataService
      .post<IntegratedAdmissionAppointment>(
        this.budgetingIntegratedAdmisionEndPoint,
        {
          Appointment: appointment,
          BudgetId: budgetId,
        }
      )
      .toPromise();
  }

  async getByPatientId(patientId: number): Promise<BudgetFilter[]> {
    return await this.dataService
      .get<BudgetFilter[]>(this.getByPatientIdEndPoint, { patientId })
      .toPromise();
  }

  async getNew(): Promise<Budget> {
    const centerId = this.authService.getCenterId();
    return await this.dataService
      .get<Budget>(this.getNewEndPoint, { centerId })
      .toPromise();
  }

  async create(budgets: Budget[]): Promise<string> {
    return await this.dataService
      .post<string>(this.createEndPoint, budgets)
      .toPromise();
  }

  async getReport(group: string): Promise<ReportViewer> {
    return await this.dataService
      .get<ReportViewer>(this.getReportEndPoint, { group })
      .toPromise();
  }
}
